module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_c('v-icon', [_vm._v("help")]), _vm._v(" "), _c('v-toolbar-title', [_vm._v("GuruSupport")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', {
    staticClass: "pa-0"
  }, [(_vm.step === 1) ? [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step = 0
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("keyboard_backspace")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })] : _vm._e(), _vm._v(" "), _c('v-text-field', {
    staticClass: "mx-1 mb-2",
    attrs: {
      "clearable": "",
      "persistent-hint": "",
      "hint": "Type a query to search our online knowledgebase",
      "prepend-icon": "search",
      "placeholder": "How do I .."
    },
    on: {
      "input": _vm.doSearch
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-spacer')], 2), _vm._v(" "), _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    staticClass: "searchresult"
  }, [(_vm.results && _vm.results.hits) ? [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("Search results\n            "), (_vm.search && _vm.search.length > 0) ? _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(" for "), _c('i', [_vm._v(_vm._s(_vm.search))])]) : _vm._e()]), _vm._v(" "), (_vm.pageCount === 1) ? _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            " + _vm._s(_vm.results.nbHits) + " results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]) : (_vm.pageCount > 1) ? _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            Showing Page " + _vm._s(_vm.pageNumber) + " of " + _vm._s(_vm.results.nbHits) + " results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]) : _c('small', {
    staticClass: "text-xs text-gray-400 ml-3"
  }, [_vm._v("\n            0 results returned in " + _vm._s(_vm.results.processingTimeMs) + "ms\n          ")]), _vm._v(" "), _vm._l((_vm.paginatedData), function(result) {
    return _c('div', {
      key: result.id
    }, [_c('v-card', {
      staticClass: "grey darken-2 mt-2",
      attrs: {
        "dark": ""
      }
    }, [_c('v-list', {
      attrs: {
        "dense": "",
        "dark": ""
      }
    }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(result._formatted.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": "",
        "href": ("https://help.appointmentguru.co/" + (result._formatted.slug) + ".html"),
        "target": "_blank"
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), (result.video_embed_url) ? _c('v-list-tile-action', {
      staticClass: "ml-0"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedVideo = result
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("videocam")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (result && result._formatted) ? _c('v-card-text', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatSummary(result._formatted.summary))
      }
    }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedArticle(result)
        }
      }
    }, [_vm._v("More\n                  "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_right")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (result.articleVisibility),
        expression: "result.articleVisibility"
      }]
    }, [_c('v-card-title', {
      staticClass: "subheading secondary darken-1"
    }, [_vm._v("\n                Article Fetched: " + _vm._s(result.title) + "\n              ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Fetched Article To Come Here\n              ")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount
    },
    on: {
      "input": _vm.nextPage
    },
    model: {
      value: (_vm.pageNumber),
      callback: function($$v) {
        _vm.pageNumber = $$v
      },
      expression: "pageNumber"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-window-item', [(_vm.selectedArticle) ? _c('v-card', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.step--
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.selectedArticle.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "href": ("https://help.appointmentguru.co/" + (_vm.selectedArticle.slug) + ".html"),
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "py-2"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedSummary)
    }
  }), _vm._v(" "), (_vm.selectedEmbed) ? _c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%"
    },
    attrs: {
      "src": _vm.selectedEmbed,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.selectedContent)
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "my-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1 justify-center",
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_vm._v("\n          Still need help?\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "dark": "",
      "href": "https://help.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_vm._v("\n          Open Knowledgebase\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "dark": "",
      "href": "https://help.appointmentguru.co/",
      "target": "_blank"
    }
  }, [_vm._v("\n          Email support\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "block": "",
      "outline": "",
      "outlined": "",
      "href": "https://book.appt.guru/?s=9",
      "target": "_blank"
    }
  }, [_vm._v("\n          Book a demo\n          "), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("open_in_new")])], 1)], 1)], 1), _vm._v(" "), (_vm.selectedVideo) ? _c('v-dialog', {
    attrs: {
      "width": "680",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "flat": "",
      "dark": ""
    },
    model: {
      value: (_vm.selectedVideo),
      callback: function($$v) {
        _vm.selectedVideo = $$v
      },
      expression: "selectedVideo"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline py-1"
  }, [_vm._v("\n        " + _vm._s(_vm.selectedVideo.title) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedVideo = null
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "padding-bottom": "70.45009784735812%",
      "height": "0"
    }
  }, [(_vm.selectedVideo) ? _c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.selectedVideo,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  }) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e608d63","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/index.vue
// module id = 1484
// module chunks = 9